import { render, staticRenderFns } from "./SkeletonTableOfContents.vue?vue&type=template&id=6267c27a"
import script from "./SkeletonTableOfContents.vue?vue&type=script&lang=js"
export * from "./SkeletonTableOfContents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports